/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DateRangeActivated,
  DateRangeActivatedOptional,
  DateRangeActivatedMetaI,
  DateRangeActivatedTrackedI,
} from "./date-range-activated";
import {
  DateRangeActivatedTracked,
  DateRangeActivatedMeta,
} from "./date-range-activated";

/**
 *
 * @export
 * @interface AgreementInstanceBase
 */
export interface AgreementInstanceBaseOptional extends DateRangeActivatedOptional {
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceBase
   */
  agreementVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementText?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementHeader?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementAgreeText?: string;
}

export interface AgreementInstanceBase
  extends AgreementInstanceBaseOptional, DateRangeActivated {
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceBase
   */
  agreementVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementText?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementHeader?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementAgreeText?: string;
}

export interface AgreementInstanceBaseTrackedI extends DateRangeActivatedOptional {
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementInstanceBase
   */
  agreementVersion?: number;
  agreementVersionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementText?: string;
  agreementTextIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementHeader?: string;
  agreementHeaderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementInstanceBase
   */
  agreementAgreeText?: string;
  agreementAgreeTextIsSet: boolean;
}

transformDatesMap.set(
  "AgreementInstanceBase",
  function (model: AgreementInstanceBase) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
  },
);

export type AgreementInstanceBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  agreementVersion: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  agreementText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementHeader: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementAgreeText: PropertyMeta<MetaTypeBase<string>>;
}>;

export var AgreementInstanceBaseMeta: AgreementInstanceBaseMetaI =
  {} as AgreementInstanceBaseMetaI;
AgreementInstanceBaseMeta = typeMeta("AgreementInstanceBase", {
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  agreementVersion: propertyMeta(
    "agreementVersion",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  agreementText: propertyMeta(
    "agreementText",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  agreementHeader: propertyMeta(
    "agreementHeader",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  agreementAgreeText: propertyMeta(
    "agreementAgreeText",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = AgreementInstanceBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DateRangeActivatedMeta]);
  metaI.startActive.inheritedFrom = DateRangeActivatedMeta.startActive;
  metaI.endActive.inheritedFrom = DateRangeActivatedMeta.endActive;
});

export class AgreementInstanceBaseTracked
  extends DateRangeActivatedTracked
  implements AgreementInstanceBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  agreementVersion__I?: number = undefined;
  agreementVersionIsSet: boolean = false;
  set agreementVersion(v: undefined | number) {
    if (v !== undefined) {
      this.agreementVersion__I = v;
      this.agreementVersionIsSet = true;
    } else {
      this.agreementVersion__I = v || undefined;
      this.agreementVersionIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementVersion() {
    return this.agreementVersion__I;
  }
  agreementText__I?: string = undefined;
  agreementTextIsSet: boolean = false;
  set agreementText(v: undefined | string) {
    if (v !== undefined) {
      this.agreementText__I = v;
      this.agreementTextIsSet = true;
    } else {
      this.agreementText__I = v || undefined;
      this.agreementTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementText() {
    return this.agreementText__I;
  }
  agreementHeader__I?: string = undefined;
  agreementHeaderIsSet: boolean = false;
  set agreementHeader(v: undefined | string) {
    if (v !== undefined) {
      this.agreementHeader__I = v;
      this.agreementHeaderIsSet = true;
    } else {
      this.agreementHeader__I = v || undefined;
      this.agreementHeaderIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementHeader() {
    return this.agreementHeader__I;
  }
  agreementAgreeText__I?: string = undefined;
  agreementAgreeTextIsSet: boolean = false;
  set agreementAgreeText(v: undefined | string) {
    if (v !== undefined) {
      this.agreementAgreeText__I = v;
      this.agreementAgreeTextIsSet = true;
    } else {
      this.agreementAgreeText__I = v || undefined;
      this.agreementAgreeTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementAgreeText() {
    return this.agreementAgreeText__I;
  }
  constructor(config?: AgreementInstanceBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: AgreementInstanceBaseOptional,
    options?: AssignOptions,
  ): AgreementInstanceBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.agreementVersion &&
      this.agreementVersionApplyFilter(optionsRequired.filter)
    ) {
      this.agreementVersion = config.agreementVersion;
      if (optionsRequired.unassign) this.agreementVersionIsSet = false;
      else this.agreementVersionIsSet = true;
    }
    if (
      config.agreementText &&
      this.agreementTextApplyFilter(optionsRequired.filter)
    ) {
      this.agreementText = config.agreementText;
      if (optionsRequired.unassign) this.agreementTextIsSet = false;
      else this.agreementTextIsSet = true;
    }
    if (
      config.agreementHeader &&
      this.agreementHeaderApplyFilter(optionsRequired.filter)
    ) {
      this.agreementHeader = config.agreementHeader;
      if (optionsRequired.unassign) this.agreementHeaderIsSet = false;
      else this.agreementHeaderIsSet = true;
    }
    if (
      config.agreementAgreeText &&
      this.agreementAgreeTextApplyFilter(optionsRequired.filter)
    ) {
      this.agreementAgreeText = config.agreementAgreeText;
      if (optionsRequired.unassign) this.agreementAgreeTextIsSet = false;
      else this.agreementAgreeTextIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementInstanceBaseTrackedI {
    const cloned = {} as AgreementInstanceBaseTrackedI;
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.agreementVersionIsSetDeep() &&
      this.agreementVersionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementVersionIsSet = true;
      cloned.agreementVersion = this.agreementVersion;
    } else {
      //cloned.agreementVersionIsSet = false
    }
    if (
      this.agreementTextIsSetDeep() &&
      this.agreementTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementTextIsSet = true;
      cloned.agreementText = this.agreementText;
    } else {
      //cloned.agreementTextIsSet = false
    }
    if (
      this.agreementHeaderIsSetDeep() &&
      this.agreementHeaderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementHeaderIsSet = true;
      cloned.agreementHeader = this.agreementHeader;
    } else {
      //cloned.agreementHeaderIsSet = false
    }
    if (
      this.agreementAgreeTextIsSetDeep() &&
      this.agreementAgreeTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementAgreeTextIsSet = true;
      cloned.agreementAgreeText = this.agreementAgreeText;
    } else {
      //cloned.agreementAgreeTextIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementInstanceBaseTrackedI {
    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.agreementVersionApplyFilter(filter))
      this.agreementVersionIsSet = false;

    if (!this.agreementTextApplyFilter(filter)) this.agreementTextIsSet = false;

    if (!this.agreementHeaderApplyFilter(filter))
      this.agreementHeaderIsSet = false;

    if (!this.agreementAgreeTextApplyFilter(filter))
      this.agreementAgreeTextIsSet = false;

    return this;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceBaseMeta.startActive,
      AgreementInstanceBaseMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceBaseMeta.endActive,
      AgreementInstanceBaseMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  agreementVersionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceBaseMeta.agreementVersion,
      AgreementInstanceBaseMeta,
      this.agreementVersion,
      this,
    );
  }
  agreementVersionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementVersionIsSet && this.agreementVersionApplyFilter(filter))
      return true;

    return false;
  }
  agreementTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceBaseMeta.agreementText,
      AgreementInstanceBaseMeta,
      this.agreementText,
      this,
    );
  }
  agreementTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementTextIsSet && this.agreementTextApplyFilter(filter))
      return true;

    return false;
  }
  agreementHeaderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceBaseMeta.agreementHeader,
      AgreementInstanceBaseMeta,
      this.agreementHeader,
      this,
    );
  }
  agreementHeaderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementHeaderIsSet && this.agreementHeaderApplyFilter(filter))
      return true;

    return false;
  }
  agreementAgreeTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementInstanceBaseMeta.agreementAgreeText,
      AgreementInstanceBaseMeta,
      this.agreementAgreeText,
      this,
    );
  }
  agreementAgreeTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementAgreeTextIsSet &&
      this.agreementAgreeTextApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.agreementVersionIsSetDeep(filter)) return true;
    if (this.agreementTextIsSetDeep(filter)) return true;
    if (this.agreementHeaderIsSetDeep(filter)) return true;
    if (this.agreementAgreeTextIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
